import { OwnedSpace } from '@sp/data/bif';

export class InvalidSpaceError extends Error {
  constructor(public readonly space: OwnedSpace) {
    super(`Invalid space ${space.id}`);
    this.name = 'InvalidSpaceError';
  }
}
